import React, { useContext, useState } from "react";
import CustomTable from "../../components/CustomTable";
import BranchAdd from "./BranchAdd";
import useApi from "../../hooks/useApi";
import {
  ListBranch,
  StatusChangeBranch,
  deleteBranch,
  StatusChangeBranchAccess,
} from "../../constants/API/API";
import useFilter from "../../hooks/useFilter";
import BranchUpdate from "./BranchUpdate";
import usePermissions from "../../hooks/usePermissions";
import { permissionKeys } from "../../constants/staffRole";
import { AppStateContext } from "../../context/AppContext";
import moment from "moment";
import { message, Button, Space, Switch } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import DeleteRecord from "../../components/DeleteRecord";
import BranchView from "./BranchView";
import { useNavigate } from "react-router";

const Branch = () => {
  const { isAdd, isDelete, isEdit, isView } = usePermissions({
    key: permissionKeys.Students,
    redirectPermissions: ["isView"],
  });
  const navigate = useNavigate();
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Branch Management");

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [filters, setFilters] = useFilter({
    sortField: "createdAt",
    sort: "desc",
    startDate: null,
    endDate: null,
  });

  const addBranch = () => {
    setAddModal(true);
  };

  const handleViewClick = (record) => {
    setSelectedBranch(record);
    setViewModal(true);
  };
  const handleEditClick = (record) => {
    setSelectedBranch(record);
    setEditModal(true);
  };

  const handleStatusChange = async (checked, employee) => {
    setLoading(true);
    try {
      await StatusChangeBranch(employee._id, { isActive: checked });
      message.success(
        `Branch ${checked ? "activated" : "deactivated"} successfully`
      );
      setRefresh(new Date().getTime()); // Refresh list
    } catch (error) {
      message.error("Failed to update status");
      setLoading(false);
    }
  };

const handleBranchAccess = async (checked, employee) => {
  setLoading(true);
  try {
    const res = await StatusChangeBranchAccess(employee._id);
    message.success(res?.data?.message || "Status updated successfully");
    setRefresh(new Date().getTime());
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Failed to update status"
    );
    setLoading(false);
  }
};


  useApi({
    callback: ListBranch,
    payload: filters,
    dependencies: [refresh, filters],
    shouldCallApi: true,
    setLoading,
    onSuccess: ({ list, totalDocs }) => {
      setData(list);
      setTotalDocs(totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, item) => (
        <>
          <p>{item?.name}</p>
        </>
      ),
    },
     {
      title: "Boutique Access",
      dataIndex: "isBranchAccess",
      key: "isBranchAccess",
      render: (text, record) => (
        <Switch
          checked={record.isBranchAccess}
          onChange={(checked) => handleBranchAccess(checked, record)}
          disabled={!isEdit}
        />
      ),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (_, { city }) => (
        <>
          <p>{city?.name}</p>
        </>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (_, item) => <div className="big-textline">{item?.address}</div>,
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    //    render: (_, item) => (
    //     <div className="big-textline">
    //       {item?.description}
    //     </div>
    //    ),
    // },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text, record) => (
        <Switch
          checked={record.isActive}
          onChange={(checked) => handleStatusChange(checked, record)}
          disabled={!isEdit}
        />
      ),
    },
   
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => moment(record.createdAt).format("ll"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => navigate(`/branch/view/${record._id}`)}
            icon={<EyeOutlined />}
            title="View"
          />
          {isEdit && (
            <Button
              type="primary"
              onClick={() => handleEditClick(record)}
              icon={<EditOutlined />}
              title="Edit"
            />
          )}
          {isDelete && (
            <DeleteRecord
              _id={record._id}
              callback={() => deleteBranch(record._id, { isDeleted: true })}
              setLoading={setLoading}
              setRefresh={setRefresh}
              trigger={true}
              type="Branch"
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <CustomTable
        addFn={addBranch}
        data={data}
        loading={loading}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        totalDocs={totalDocs}
        searchField={["name", "address"]}
        showCompareBranch={true}
        searchPlaceholder="Search by name or address"
      />
      {addModal && (
        <BranchAdd
          visible={addModal}
          setVisible={setAddModal}
          refresh={setRefresh}
        />
      )}
      {editModal && selectedBranch && (
        <BranchUpdate
          editVisible={editModal}
          setEditVisible={setEditModal}
          selectedBranch={selectedBranch}
          refresh={setRefresh}
        />
      )}
      {viewModal && selectedBranch && (
        <BranchView
          visible={viewModal}
          setVisible={setViewModal}
          selectedBranch={selectedBranch}
          refresh={setRefresh}
        />
      )}
    </div>
  );
};

export default Branch;
